class CardRecentAgenda {
  private modal: HTMLElement | null = null;
  private modalText: HTMLElement | null = null;
  private modalTitle: HTMLElement | null = null;

  constructor() {
    this.init();
  }

  private init(): void {
    this.setupModal();
    this.checkTextOverflow();
    this.bindEvents();
  }

  private setupModal(): void {
    this.modal = document.getElementById('agenda-modal');
    this.modalText =
      this.modal?.querySelector('.card-recent-agenda-modal-text') || null;
    this.modalTitle =
      this.modal?.querySelector('.card-recent-agenda-modal-title') || null;
  }

  private checkTextOverflow(): void {
    const excerptElements = document.querySelectorAll(
      '.card-recent-agenda-excerpt'
    );

    excerptElements.forEach((excerpt) => {
      const element = excerpt as HTMLElement;
      const seeMoreButton = element.parentElement?.querySelector(
        '.card-recent-agenda-see-more'
      ) as HTMLElement;

      if (seeMoreButton) {
        const textContent = element.textContent || '';

        // Vérifier différents types d'ellipses WordPress
        const hasWordPressEllipsis =
          textContent.endsWith('...') ||
          textContent.endsWith('…') ||
          textContent.includes('[...]') ||
          textContent.length > 100; // Fallback pour texte long

        if (hasWordPressEllipsis) {
          seeMoreButton.style.display = 'inline';
        } else {
          seeMoreButton.style.display = 'none';
        }
      }
    });
  }

  private bindEvents(): void {
    document.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;
      if (!target) return;

      const seeMoreButton = target.closest(
        '[data-action="see-more"]'
      ) as HTMLElement;
      if (seeMoreButton) {
        e.preventDefault();
        this.handleSeeMoreClick(seeMoreButton);
        return;
      }

      const closeButton = target.closest(
        '[data-action="close-modal"]'
      ) as HTMLElement;
      if (closeButton) {
        e.preventDefault();
        this.closeModal();
        return;
      }

      // Fermer le modal en cliquant sur l'overlay
      if (target.classList.contains('card-recent-agenda-modal-overlay')) {
        this.closeModal();
        return;
      }
    });

    // Fermer le modal avec la touche Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal?.style.display === 'block') {
        this.closeModal();
      }
    });
  }

  private handleSeeMoreClick(button: HTMLElement): void {
    const fullText = button.getAttribute('data-full-text');
    const cardElement = button.closest('.card-recent-agenda');
    const titleElement = cardElement?.querySelector(
      '.card-recent-agenda-title'
    ) as HTMLElement;

    if (fullText && this.modal && this.modalText && this.modalTitle) {
      this.modalText.innerHTML = fullText;
      this.modalTitle.innerHTML =
        titleElement?.textContent || "Détails de l'événement";
      this.openModal();
    }
  }

  private openModal(): void {
    if (this.modal) {
      this.modal.style.display = 'block';
      document.body.style.overflow = 'hidden'; // Empêcher le scroll de la page
    }
  }

  private closeModal(): void {
    if (this.modal) {
      this.modal.style.display = 'none';
      document.body.style.overflow = 'auto'; // Restaurer le scroll de la page
    }
  }
}

// Initialiser quand le DOM est prêt
document.addEventListener('DOMContentLoaded', () => {
  new CardRecentAgenda();
});

// Export pour utilisation externe si nécessaire
export default CardRecentAgenda;
